import { useLang } from '@/i18n';
import EfHighlights from '@elem/ui/ef-highlights';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import styles from './index.module.scss';
import ItemA from './ItemA';
import ItemB from './ItemB';
import ItemC from './ItemC';
import ItemD from './ItemD';
import ItemE from './ItemE';
import ItemF from './ItemF';
import ItemG from './ItemG';
import ItemH from './ItemH';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    const listA = [
        {
            children: <ItemA />,
        },
        {
            children: <ItemB />,
        },
        {
            children: <ItemC />,
        },
        {
            children: <ItemD />,
        },
        {
            children: <ItemE />,
        },
        {
            children: <ItemF />,
        },
        {
            children: <ItemG />,
        },
        {
            children: <ItemH />,
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfTitle hasAnimation={false}>{t('title')}</EfTitle>
            <EfHighlights items={listA} />
            <EfSpec />
        </div>
    );
}
